import axios from "axios";

import { IP } from "../utils/Host";


export function updateZmienCzasTrwaniaGrupyOprawaGant(drop_grupa_global_id,nowy_koniec,refreshGantAll) {

// id = procesor id

  axios.get(IP + "zmienCzasTrwaniaGrupyOprawa/"+drop_grupa_global_id+"/"+nowy_koniec+"/" + sessionStorage.getItem("token"))
    .then((res) => {
    // console.log("procesor " +res.data[0].mcr)
    // fechparametryTechnologii
    refreshGantAll()

    });
}
